import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';

import { copyToClipboard, IconModule } from '@hglobal/fin-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { Account } from '@iw/core/entities';
import { IwDecimalPipe, MaskBalancePipe } from '@iw/core/pipes';
import { GlobalToastService } from '@iw/core/services';

import { ButtonComponent } from '../../button';
import { CardViewSize } from '../card-view.model';

@Component({
  selector: 'iw-crypto-wallet',
  imports: [
    NgClass,
    ButtonComponent,
    IconModule,
    TranslateModule,
    MaskBalancePipe,
    IwDecimalPipe,
  ],
  templateUrl: './crypto-wallet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './crypto-wallet.component.scss',
})
export class CryptoWalletComponent {
  readonly #toast = inject(GlobalToastService);
  readonly #translate = inject(TranslateService);

  readonly wallet = input<Account>();
  readonly size = input<CardViewSize>();
  readonly iconSize = input<Record<CardViewSize, number>>();
  readonly useBalanceMask = input<boolean>(false);

  readonly showNetwork = computed(() => {
    const currency = this.wallet().currency;
    return !!currency.network && currency.network !== currency.symbol;
  });

  async copy(address: string, translate: string) {
    await copyToClipboard(address);
    this.#toast.showSuccess(this.#translate.instant(translate));
  }

  shortAddress(address?: string): string {
    if (!address) return '';
    if (address.length < 8) return address;
    return `${address.slice(0, 4)}....${address.slice(-4)}`;
  }
}
